import { useEffect, useState } from 'react';
import { HOT_EDIT_ASK_IDEOZ_EVENT } from '@ideoz/workbench';

/**
 * The editor's "Ask Ideoz about this element": the chat takes the founder's cursor so they can
 * type. The element itself rides on the composer as a chip (`AskElementChip`) and travels with
 * the message; nothing technical is written into the composer any more.
 */
export function useHotEditAskDraft(): { text?: string; nonce: number } | null {
  const [draft, setDraft] = useState<{ text?: string; nonce: number } | null>(null);
  useEffect(() => {
    const onAsk = (ev: Event): void => {
      const text = (ev as CustomEvent<{ text?: unknown }>).detail?.text;
      setDraft({ ...(typeof text === 'string' && text.trim() ? { text } : {}), nonce: Date.now() });
    };
    window.addEventListener(HOT_EDIT_ASK_IDEOZ_EVENT, onAsk);
    return () => window.removeEventListener(HOT_EDIT_ASK_IDEOZ_EVENT, onAsk);
  }, []);
  return draft;
}
